import { render } from "./texturePanel.vue?vue&type=template&id=57205dff"
import script from "./texturePanel.vue?vue&type=script&lang=js"
export * from "./texturePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__